<template>
  <div class="vip-level">
    <TableComponent
      :tableData="tableData"
      :pagination="pagination"
      @updateData="_updateStore"
    >
      <template #default="{handleDelete}">
        <el-table-column fixed type="selection" align="center" width="140" />
        <el-table-column prop="id" label="序号" align="center" min-width="60" />
        <el-table-column align="center" label="会员等级徽章" min-width="180">
          <template slot-scope="scope">
            <span class="level-img">
              <i class="iconfont icon-v" />
              <i class="level">{{ scope.row.id }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="levelName"
          align="center"
          label="会员等级名称"
          min-width="180"
        />
        <el-table-column
          prop="consume"
          label="累积消费金额"
          align="center"
          min-width="180"
        />
        <el-table-column label="折扣力度" align="center" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.discount | formatDiscount($store) }}
          </template>
        </el-table-column>
        <el-table-column label="自动升级" align="center" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.automationLevel | formatAutomationLevel }}
          </template>
        </el-table-column>
        <el-table-column
          prop="txtIntegral"
          label="文字点评积分"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="imgTxtIntegral"
          label="图文点评积分"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="replyIntegral"
          label="回复积分"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="likeIntegral"
          label="点赞获得积分"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="checkInIntegral"
          label="签到获得积分"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="salesRatio"
          label="消费积分比例"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="rechargeRatio"
          label="充值积分比例"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="perfectingIntegral"
          label="完善信息获得积分"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="integralDiscount"
          label="积分折扣"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="integralDiscountRatio"
          label="积分折扣比例"
          align="center"
          min-width="180"
        />
        <el-table-column
          fixed="right"
          label="操作"
          align="center"
          min-width="180"
          class-name="visible"
        >
          <template slot-scope="scope">
            <el-button
              size="36"
              round
              class="iconfont icon-bianji"
              v-permission:editor="$route.meta.permission"
              @click="jumpNewLevel(scope.row)"
            />
            <el-button
              size="36"
              round
              class="iconfont icon-shanchu"
              @click="handleDelete(scope.$index, scope.row)"
              v-permission:del="$route.meta.permission"
            />
          </template>
        </el-table-column>
      </template>
    </TableComponent>
    <el-button
      size="220"
      round
      class="iconfont icon-xinzeng"
      @click="jumpNewLevel"
      v-permission:add="$route.meta.permission"
    >
      新增等级
    </el-button>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import TableComponent from '../Components/TableComponent/'
import updateData from 'mixins/updateData'
const { mapMutations } = createNamespacedHelpers('vipLevel')
export default {
  name: 'vipLevel',
  mixins: [updateData],
  components: {
    TableComponent
  },
  data() {
    this.keyMap = {
      level_list: {
        name: 'tableData',
        level_id: 'id',
        level_name: 'levelName',
        consume_sum: 'consume',
        cumulative_integral: 'integral',
        discount_id: 'discount',
        auto_update: 'automationLevel',
        written_comment_points: 'txtIntegral',
        imagetext_comment_points: 'imgTxtIntegral',
        integral_accumulation: 'integralAccumulation',
        reply_points: 'replyIntegral',
        like_points: 'likeIntegral',
        sign_points: 'checkInIntegral',
        consumption_integral_proportion: 'salesRatio',
        recharge_integral_proportion: 'rechargeRatio',
        perfecting_information_points: 'perfectingIntegral',
        integral_deduction: 'integralDiscount',
        points_deduction_integral_proportion: 'integralDiscountRatio',
        written_comment_number: 'txtNum',
        imagetext_comment_number: 'imgTxtNum',
        imagetext_sheets_number: 'imgNum',
        written_number: 'writeNum',
        reply_number: 'replyNum',
        like_number: 'likeNum',
        sign_number: 'checkInNum',
        deduction_ration: 'orderRatio'
      }
    }
    return {
      tableData: [],
      pagination: {}
    }
  },
  filters: {
    formatAutomationLevel(value) {
      const type = ['否', '自动']
      return type[+value]
    }
  },
  created() {
    this._getVipLevelList({ curpage: 1 })
  },
  methods: {
    ...mapMutations({
      saveInfo: 'CHANGE_VIPLEVEL'
    }),
    ...mapActions(['_getAllDownData']),
    /**
     * 获取内容
     */
    _getVipLevelList(params) {
      this.api.getVipLevelList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 跳转新增等级页面
     * @param row
     */
    jumpNewLevel(row) {
      if (row) {
        const { id, levelName } = row
        row.automationLevel = +row.automationLevel
        row.integralDiscount = +row.integralDiscount
        row.integralAccumulation = +row.integralAccumulation
        this.saveInfo(row)
        this.$router.push({
          name: 'addNewLevel',
          query: {
            id: id,
            title: levelName
          }
        })
      } else {
        this.$router.push({ name: 'addNewLevel' })
      }
    },
    /**
     * 额外刷新store DownData数据
     * @param cb
     * @param newValue
     * @param type
     * @private
     */
    _updateStore(cb, newValue, type) {
      this._getAllDownData()
      this._updateData(cb, newValue, type)
    }
  }
}
</script>
<style lang="scss">
.vip-level {
  .level-img {
    position: relative;

    .level {
      position: absolute;
      top: -3px;
      left: 0.5rem;
      color: #d5b588;
      font-style: normal;
      width: 100%;
    }

    .icon-v:before {
      color: #d5b588;
      font-size: 1.3rem;
    }
  }
}
</style>
